module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/LadiesinLavender-448x252.a72a606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/LadiesinLavender-448x252.jpg
// module id = f995
// module chunks = 0